import { useBlogList } from "~/hooks/blog/useBlogList";

interface IUseHome {
    page?: number;
    pageSize?: number;
    name?: string;
}
const useHome = (props: IUseHome = {}) => {
  const { data: blogs, isLoading, refetch } = useBlogList(props);

  return {
    blogs,
    isLoading,
    refetch,
  };
};

export default useHome;
